export class TabsManagedDoesntExist extends Error {}

export class TabsManager {
  static KEY = 'Tabs-Manager-Stack';

  constructor() {
    if (!this.exists()) {
      this.update([]);
    }
  }

  public purge() {
    if (this.exists()) {
      this.update([]);
    }
  }

  public addTab(tabID: string) {
    if (!this.includes(tabID)) {
      const tabs = this.getTabs();
      this.update([...tabs, tabID]);
    }

    return this;
  }

  public removeTab(tabID: string) {
    if (this.includes(tabID)) {
      const tabs = this.getTabs();
      this.update(tabs.filter(item => item !== tabID));
    }

    return this;
  }

  public tabsCount() {
    if (this.exists()) {
      return this.getTabs().length;
    } else {
      throw new TabsManagedDoesntExist('Tabs Manager doesn\'t exist.');
    }
  }

  private exists() {
    return Boolean(localStorage.getItem(TabsManager.KEY));
  }

  private getTabs() {
    return JSON.parse(localStorage.getItem(TabsManager.KEY) as string) as string[];
  }

  private update(tabs: string[]) {
    localStorage.setItem(TabsManager.KEY, JSON.stringify(tabs));
  }

  private includes(tabID: string) {
    if (this.exists()) {
      const tabs = JSON.parse(localStorage.getItem(TabsManager.KEY) as string);
      return (tabs instanceof Array) && tabs.includes(tabID);
    } else {
      throw new TabsManagedDoesntExist('Tabs Manager doesn\'t exist.');
    }
  }
}

export const tabManager = new TabsManager();